module.exports = __webpack_public_path__ + "img/93.bb951ff9.jpg";